export const sampleArticle = {
  id: "article-ai-growth",
  title: "AI时代的内容增长方法论",
  titleCandidates: [
    "AI时代的内容增长方法论",
    "从单篇爆文到持续生产：AI 内容工作流怎么搭",
    "公众号创作者如何用 AI 建立稳定产出系统"
  ],
  summary:
    "真正有效的内容增长，不是追逐每一次热点，而是建立一套能持续产出、持续检查、持续复用的创作流程。",
  sections: [
    {
      id: "sec-process",
      heading: "从灵感驱动到流程驱动",
      paragraphs: [
        "过去，很多创作者依赖灵感和经验来完成文章：想到一个题目，临时找一些资料，再凭手感写出正文。这种方式可以偶尔产出好文章，但很难稳定复制。",
        "AI 时代的内容增长，需要把创作拆成更清楚的环节：输入主题或素材、整理关键观点、生成结构、补充论据、检查风险、形成适合公众号阅读的排版。"
      ]
    },
    {
      id: "sec-beyond-draft",
      heading: "好的 AI 写作，不应该只停在正文生成",
      paragraphs: [
        "如果工具只生成一篇文章，用户仍然要自己判断标题是否吸引人、结构是否完整、事实是否可靠、表达是否符合账号调性。",
        "真正节省时间的产品，应该帮助用户完成从草稿到可发布的后半程。"
      ]
    },
    {
      id: "sec-system",
      heading: "增长来自可复用的内容系统",
      paragraphs: [
        "当创作者每次都从零开始，增长就会变得非常消耗。更好的做法是沉淀常用语气、目标读者、排版模板和检查规则，让下一篇文章从更高的起点开始。",
        "AI 不只是提效工具，更是放大内容策略、稳定内容质量的协作伙伴。"
      ]
    }
  ],
  imageSuggestions: [
    {
      id: "img-cover",
      title: "内容流水线封面图",
      description: "用输入、结构、检查、发布四段式视觉表达内容生产中枢。",
      placement: "封面"
    },
    {
      id: "img-process",
      title: "流程图插图",
      description: "放在第一节后，表达从灵感驱动到流程驱动。",
      placement: "第一节后"
    }
  ],
  quoteCandidates: [
    "AI 不只是提效工具，更是放大内容策略、稳定内容质量的协作伙伴。",
    "真正有效的增长来自可复用的内容系统。"
  ],
  sourceWarnings: ["涉及平台规则、增长数据或研究结论时，需要在发布前人工确认来源。"]
};

export const sampleProjects = [
  {
    id: "p1",
    title: "AI时代的内容增长方法论",
    updatedAt: "今天 16:42",
    score: 88,
    inputType: "主题",
    article: sampleArticle
  },
  {
    id: "p2",
    title: "普通人如何用 AI 提升公众号写作效率",
    updatedAt: "今天 14:18",
    score: null,
    inputType: "素材",
    article: {
      ...sampleArticle,
      id: "article-writing-efficiency",
      title: "普通人如何用 AI 提升公众号写作效率"
    }
  },
  {
    id: "p3",
    title: "企业新媒体团队的内容流水线",
    updatedAt: "昨天 21:06",
    score: 92,
    inputType: "链接",
    article: {
      ...sampleArticle,
      id: "article-team-pipeline",
      title: "企业新媒体团队的内容流水线"
    }
  }
];
